module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"karana":"-я карана","karana1":"Бава","karana2":"Балава","karana3":"Каулава","karana4":"Тайтила","karana5":"Гара","karana6":"Ваниджа","karana7":"Вишти","karana8":"Шакуни","karana9":"Чатушпада","karana10":"Нага","karana11":"Кинстугхана","diety":"Покровитель"}}')
  delete Component.options._Ctor
}
